import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "listFilter",
  standalone: true,
})
export class ListFilterPipe implements PipeTransform {
  public transform(list: any[], filterText: string): any {
    return list
      ? list.filter(
          (item) => item.title.search(new RegExp(filterText, "i")) > -1,
        )
      : [];
  }
}
